import * as qs from 'qs';
import { axios } from '~/libs/axios';
import {
  type CreateMessageResponse,
  type Page,
  type PaginationOptions,
  type TMessage,
} from '~/types';
import { ExclusiveRunner } from '~/libs/async';

const runner = ExclusiveRunner.create();

const getAll = async (
  chatID: string,
  options?: PaginationOptions,
): Promise<Page<TMessage>> => {
  const queryParams = qs.stringify({
    page: options?.page || 1,
    size: options?.size || 50,
  });

  const { data } = await runner.run({
    key: ['messages', 'getAll', chatID, queryParams],
    fn: async () =>
      await axios.get<Page<TMessage>>(
        `/chats/${chatID}/messages?` + queryParams,
      ),
  });

  return data;
};

const create = async (
  chatID: string,
  text: string,
): Promise<CreateMessageResponse> => {
  const { data } = await axios.post<CreateMessageResponse>(
    `/chats/${chatID}/messages`,
    { prompt: text },
  );
  return data;
};

export const messagesAPI = {
  getAll,
  create,
};
